import React from "react";

const Ticari_iletisim_aydinlatma_metni = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>TİCARİ İLETİŞİM VE PAZARLAMA VERİLERİ AYDINLATMA METNİ</h1>

        <section style={styles.section}>
          <p style={styles.text}>
            İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") ve ilgili
            mevzuata uygun olarak, kişisel verilerinizin veri sorumlusu olarak Von Dijital Yazılım
            Hizmetleri LTD. ŞTİ. ("Şirket") nezdinde işlenmesine ilişkin esasları açıklamak amacıyla
            hazırlanmıştır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Kişisel Verilerin İşlenme Amacı</h2>
          <p style={styles.text}>
            Şirketimiz, pazarlama faaliyetlerinin yürütülmesi, mevcut ve potansiyel kullanıcılarımızın
            bilgilendirilmesi, ürün ve hizmetlerimizin tanıtımı ile kullanıcı memnuniyetinin artırılması
            amacıyla, tarafınızdan ticari elektronik ileti gönderimine onay verilmesi veya Şirketimiz ile
            mevcut ticari ilişkiniz kapsamında sağlanan iletişim bilgilerinizi işlemektedir. Bu
            çerçevede, adınız, soyadınız, telefon numaranız ve e-posta adresiniz gibi iletişim
            bilgileriniz, Şirketimiz tarafından gerçekleştirilmekte olan pazarlama ve tanıtım
            faaliyetlerinin etkin şekilde yürütülmesi, kampanya, promosyon, ürün ve hizmet
            duyurularının yapılması, marka bilinirliğinin artırılması, müşteri memnuniyetine yönelik
            anket ve değerlendirme çalışmalarının gerçekleştirilmesi, yeni ürün ve hizmetlerin
            tanıtımı ve dijital pazarlama stratejilerinin planlanması ve uygulanması gibi amaçlarla
            işlenmektedir.
          </p>
          <p style={styles.text}>
            İşlenen verileriniz aracılığıyla tarafınıza SMS, mobil uygulama içi bildirimler, e-posta,
            otomatik arama sistemleri, telefonla arama, sosyal medya ve diğer elektronik iletişim
            kanalları yoluyla ticari elektronik ileti gönderilebilmektedir. Bu iletişim faaliyetleri,
            kullanıcılarımıza doğrudan veya dolaylı olarak ulaşabilmek ve pazarlama faaliyetlerimizi
            daha etkin şekilde yürütmek için yürütülmektedir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h2>
          <p style={styles.text}>
            Uygulamamıza üyelik oluşturma sürecinde işlenen kişisel veriler, bireysel kullanıcıların
            mobil uygulama üzerinden üyelik formunu doldurması veya kurumsal kullanıcıların
            internet sitemiz aracılığıyla ilgili kayıt ve başvuru formlarını iletmesi suretiyle tarafımızla
            paylaşılmaktadır. Bu kapsamda kişisel verileriniz, üyelik işlemlerinin yürütülmesi
            amacıyla tamamen veya kısmen otomatik olan yöntemlerle ya da gerektiğinde fiziki
            ve/veya elektronik ortamlarda sözlü, yazılı veya görsel yollarla, veri kayıt sisteminin bir
            parçası olacak şekilde elde edilmekte ve işlenmektedir. Kullanıcı tarafından Şirketimizle
            kurulan sözleşmesel ilişki çerçevesinde sağlanan bilgiler de aynı kapsamda toplanarak
            işlenmektedir.
          </p>
          <p style={styles.text}>
            Şirketimiz, kişisel verilerin işlenmesinde 6698 sayılı Kişisel Verilerin Korunması
            Kanunu'nun 5. maddesinde düzenlenen hukuka uygunluk sebeplerine dayanmakta olup;
            kişisel verileriniz, Kanun'un 5/2(c) bendi uyarınca bir sözleşmenin kurulması veya ifasıyla
            doğrudan doğruya ilgili olması kaydıyla sözleşmenin tarafı olan bireysel veya kurumsal
            kullanıcılara ait verilerin işlenmesinin gerekli olması; Kanun'un 5/2(ç) bendi uyarınca veri
            sorumlusu sıfatıyla Şirketimizin hukuki yükümlülüklerini yerine getirebilmesi için zorunlu
            olması; Kanun'un 5/2(e) bendi uyarınca bir hakkın tesisi, kullanılması veya korunması için
            veri işlemenin gerekli olması; ve Kanun'un 5/2(f) bendi uyarınca ilgili kişinin temel hak ve
            özgürlüklerine zarar vermemek kaydıyla Şirketimizin meşru menfaatleri doğrultusunda
            veri işlenmesinin zorunlu olması hukuki sebeplerine dayanılarak işlenmektedir. Tüm bu
            işleme faaliyetleri, KVKK'da yer alan genel ilkelere uygun olarak ve kişisel verilerin
            güvenliğinin sağlanması için gerekli teknik ve idari tedbirler alınarak yürütülmektedir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. İşlenen Kişisel Verilerin Aktarıldığı Yerler ve Aktarım Amacı</h2>
          <p style={styles.text}>
            Elde edilen kişisel verileriniz, işleme amaçlarıyla bağlantılı ve ölçülü olmak kaydıyla;
            hizmet süreçlerimizin yürütülmesi, sistem güvenliğinin sağlanması, uygulama ve internet
            sitesi altyapısının işletilmesi, teknik ihtiyaçların karşılanması ve operasyonel faaliyetlerin
            kesintisiz şekilde sürdürülebilmesi için destek aldığımız tedarikçiler ile iş ortaklarımıza,
            Şirket iştiraklerimize ve iş süreçlerinde kullanılan yazılım, altyapı ve bulut bilişim
            hizmetlerini sağlayan teknik çözüm ortaklarımıza aktarılabilmektedir. Kullanılan bulut
            bilişim hizmetlerinin sunucularının yurt dışında konumlanmış olması nedeniyle kişisel
            verileriniz, Kanun'un 9. maddesinde yer alan yurt dışına aktarım şartlarına uygun şekilde
            yurt dışına da aktarılabilmektedir. Ayrıca kişisel verileriniz, hukuki yükümlülüklerimizin
            yerine getirilebilmesi amacıyla kanunen yetkili kamu kurum ve kuruluşlarına, resmi
            mercilere ve Kanun'da öngörülen istisnalar kapsamında zorunlu hallerde ilgili özel
            kişilere, KVKK'nın 8. ve 9. maddelerinde düzenlenen kişisel veri işleme şartları ve aktarım
            amaçlarına uygun olarak aktarılabilecektir. Kişisel verilerin aktarımı, veri işleme amacı ile
            tamamen paralel şekilde gerçekleştirilmekte olup, tüm aktarım süreçlerinde KVKK'da
            düzenlenen temel ilkelere uygun hareket edilmektedir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Kişisel Verilerinizin Saklanma Süresi</h2>
          <p style={styles.text}>
            Kişisel verileriniz, Şirketimiz ile aranızda kurulan sözleşmesel ilişkinin gerekliliklerinin
            yerine getirilmesi, tarafımıza yüklenen yasal sorumlulukların ifa edilmesi ve veri işleme
            faaliyetlerinin dayandığı amaçların sürdürülebilirliği için gerekli olduğu müddetçe
            işlenmekte ve saklanmaktadır. Bu kapsamda, kişisel verileriniz; üyelik ve hizmet
            ilişkisinin başlatılmasından sona ermesine kadar geçen tüm süreç boyunca, sözleşmenin
            ifası için zorunlu olduğu ölçüde işlenmekte; sözleşmenin sona ermesini müteakip ise ilgili
            mevzuatta öngörülen saklama süreleri, ispat yükümlülükleri, zamanaşımı süreleri ve
            Şirketimizin meşru menfaatleri doğrultusunda gerekli görülen süre kadar muhafaza
            edilmektedir. Tarafımıza yöneltilebilecek hukuki taleplerin değerlendirilmesi veya hukuki
            hakların korunması gereken durumların varlığı hâlinde, kişisel verilerin saklama süresi
            mevzuatın öngördüğü daha uzun sürelerle devam edebilmektedir.
          </p>
          <p style={styles.text}>
            Şirketimiz, kişisel verilerinizin güvenliği, bütünlüğü ve gizliliğinin korunmasını en temel
            önceliklerinden biri olarak görmekte olup; verilerin yetkisiz erişim, ifşa, kayıp, değişiklik
            veya kötüye kullanım risklerine karşı korunması amacıyla güncel teknik imkânlara uygun
            idari, teknik ve fiziksel güvenlik kontrollerini uygulamaktadır. Bu doğrultuda, veri
            güvenliğini sağlamak amacıyla erişim yetkilerinin sınırlandırılması, ağ ve sistem güvenlik
            tedbirlerinin alınması, düzenli denetim ve log kayıtlarının tutulması gibi çok katmanlı
            koruma mekanizmaları kullanılmakta; veri işleme faaliyetleri ilgili mevzuata ve şirket içi
            politikalarımıza tam uyum içinde yürütülmektedir.
          </p>
          <p style={styles.text}>
            Kişisel verileriniz, yukarıda belirtilen amaçlar bakımından işlenmesine veya
            saklanmasına artık ihtiyaç kalmadığında, ilgili mevzuat çerçevesinde mümkün olan en
            kısa süre içerisinde silinmekte, yok edilmekte veya kimlik belirleyici unsurları tamamen
            ortadan kaldırılacak şekilde anonim hale getirilmektedir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Veri Sorumlusuna Başvuru Yolları ve Haklarınız</h2>
          <p style={styles.text}>
            6698 sayılı Kişisel Verilerin Korunması Kanunu'nun 11. maddesi uyarınca, ilgili kişi
            sıfatıyla Şirketimize başvurarak kişisel verilerinizle ilgili çeşitli haklara sahipsiniz. Bu
            kapsamda; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmiş olması hâlinde
            buna ilişkin bilgi talep etme, verilerinizin işlenme amacını ve bu amaçlara uygun şekilde
            kullanılıp kullanılmadığını öğrenme, kişisel verilerinizin yurt içinde veya yurt dışında
            aktarıldığı üçüncü tarafları bilme, eksik ya da hatalı işlenmiş verilerin düzeltilmesini talep
            etme, Kanun'un 7. maddesi çerçevesinde kişisel verilerinizin silinmesini veya yok
            edilmesini isteme, verilerin aktarılmış olduğu üçüncü kişilere bu işlemlerin bildirilmesini
            talep etme, münhasıran otomatik sistemler ile yapılan analizler sonucunda kişi aleyhine
            bir sonucun ortaya çıkması hâlinde bu sonuca itiraz etme ve kişisel verilerin hukuka aykırı
            olarak işlenmesi nedeniyle zarara uğramanız hâlinde bu zararın giderilmesini talep etme
            haklarına sahipsiniz.
          </p>
          <p style={styles.text}>
            Söz konusu talepler, "Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ"
            hükümlerine uygun olarak Şirketimize iletilmelidir. Haklarınıza ilişkin başvurularınızı yazılı
            olarak "Göztepe Mah. Mithatpaşa Cad. Gürsoy No: 856/1B Konak/İzmir" adresine iletebilir
            veya kayıtlı elektronik posta (KEP), güvenli elektronik imza ya da e-posta yoluyla
            (info@vondigital.com.tr) üzerinden tarafımıza gönderebilirsiniz.
          </p>
          <p style={styles.text}>
            Şirketimiz, iletilen başvuruları talebin niteliğine göre en kısa sürede ve en geç otuz gün
            içinde sonuçlandıracaktır. İlk başvuru ücretsiz olarak değerlendirilmekte olup; aynı
            konuyla ilgili tekrarlanan talepler veya başvurunun ayrıca bir maliyet gerektirmesi
            hâlinde, KVKK'nın ilgili hükümleri doğrultusunda ücret talep edilebilecektir. Başvurunun
            değerlendirilmesi sonucunda talebiniz kabul edilebilir veya gerekçesi açıklanarak yazılı
            şekilde reddedilebilir.
          </p>
          <p style={styles.text}>
            Başvurunun reddedilmesi, verilen cevabın yetersiz bulunması veya kanuni süre içerisinde
            yanıt verilmemesi durumlarında; ilgili kişi, cevabın kendisine tebliğinden itibaren otuz gün
            içinde ve her hâlükârda başvuru tarihinden itibaren altmış günü aşmamak kaydıyla Kişisel
            Verileri Koruma Kurulu'na şikâyette bulunma hakkına sahiptir. Kurula doğrudan şikâyet
            yoluna başvurulabilmesi için öncelikle Şirketimize yapılacak başvuru yolunun tüketilmesi
            zorunludur.
          </p>
          <p style={styles.text}>
            Kurul, kendisine iletilen şikâyet üzerine ya da bir ihlal iddiasını resen öğrenmesi hâlinde
            kendi görev alanına giren konulara ilişkin gerekli incelemeleri yapar. Yapılan incelemeler
            sonucunda, kişisel veri işleme faaliyetlerinde hukuka aykırılık tespit edilmesi hâlinde, bu
            aykırılıkların veri sorumlusu tarafından giderilmesine karar verir ve ilgili karar veri
            sorumlusuna tebliğ edilir. Şirketimiz, Kurul tarafından verilen kararları en geç otuz gün
            içinde yerine getirmekle yükümlüdür. Ayrıca Kurul, açık bir hukuka aykırılık ve telafisi güç
            sonuçların ortaya çıkabileceği durumlarda, kişisel veri işleme faaliyetlerinin veya kişisel
            verilerin yurt dışına aktarımının durdurulmasına karar verebilir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Aydınlatma Metni Değişikliği veya Güncellenmesi</h2>
          <p style={styles.text}>
            Şirketimiz, teknolojide yaşanan gelişmeler, hizmet süreçlerinde meydana gelen
            değişiklikler, mevzuatta yapılan düzenlemeler veya veri işleme faaliyetlerimizi
            etkileyebilecek diğer gereklilikler doğrultusunda işbu Aydınlatma Metnini güncelleme,
            yenileme veya yeniden düzenleme hakkını saklı tutmaktadır. Aydınlatma Metni, ihtiyaç
            duyulan durumlarda periyodik olarak gözden geçirilmekte ve gerekli görülmesi hâlinde
            yeni sürümü yürürlüğe alınmaktadır. Yapılan değişiklikler, kullanıcılarımızın erişimine
            sunulmak üzere bu sayfada yayımlanacak ve güncellenen versiyona ilişkin son revizyon
            tarihi açıkça belirtilecektir. Bu nedenle, metinde yapılan güncellemeleri takip
            edebilmeniz adına ilgili sayfayı düzenli olarak kontrol etmenizi önemle tavsiye ederiz.
          </p>
          <p style={styles.text}>
            Aydınlatma Metni'ne ilişkin her türlü soru, görüş ve talepleriniz için bizimle
            info@vondigital.com.tr adresi üzerinden iletişime geçebilirsiniz. Şirketimiz, KVKK
            kapsamındaki yükümlülükler doğrultusunda iletilen geri bildirimleri titizlikle
            değerlendirmekte ve en kısa sürede yanıtlamaktadır.
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
    color: "#555",
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

export default Ticari_iletisim_aydinlatma_metni;